<template>
    <error-content code="404" :desc="L('Validate.Error404')" :src="src"/>
</template>

<script>
    import base from '../../../lib/utils/types/base'
    import error404 from '@/assets/img/error-page/error-404.svg'
    import errorContent from './components/error-content.vue'
    export default {
        name: 'error_404',
        components: {
            errorContent
        },
        data () {
            return {
                src: error404
            }
        },
        methods:{
            L(key){
                return base.L(key);
            }
        }
    }
</script>
